import { render } from "./UnpublishBlogPostDialog.vue?vue&type=template&id=70e8e463"
import script from "./UnpublishBlogPostDialog.vue?vue&type=script&lang=js"
export * from "./UnpublishBlogPostDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__